/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const sessionResponseOutputUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const sessionResponseOutputUserDisplayNameMax = 200;

export const sessionResponseOutputUserVersionExclusiveMin = 0;
export const sessionResponseOutputUserVersionMax = 9007199254740991;

export const sessionResponseOutputSessionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const sessionResponseOutputCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const sessionResponseOutputIdleExpiresAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const sessionResponseOutputAbsoluteExpiresAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const sessionResponseOutputCsrfTokenMin = 32;
export const sessionResponseOutputCsrfTokenMax = 128;

export const SessionResponseOutput = zod.object({
  user: zod.object({
    id: zod.uuid().regex(sessionResponseOutputUserIdRegExp),
    displayName: zod.string().min(1).max(sessionResponseOutputUserDisplayNameMax),
    corporateState: zod.enum(['active', 'deactivated']),
    role: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
    version: zod
      .int()
      .gt(sessionResponseOutputUserVersionExclusiveMin)
      .max(sessionResponseOutputUserVersionMax),
  }),
  sessionId: zod.uuid().regex(sessionResponseOutputSessionIdRegExp),
  createdAt: zod.iso.datetime({ offset: true }).regex(sessionResponseOutputCreatedAtRegExp),
  idleExpiresAt: zod.iso.datetime({ offset: true }).regex(sessionResponseOutputIdleExpiresAtRegExp),
  absoluteExpiresAt: zod.iso
    .datetime({ offset: true })
    .regex(sessionResponseOutputAbsoluteExpiresAtRegExp),
  csrfToken: zod
    .string()
    .min(sessionResponseOutputCsrfTokenMin)
    .max(sessionResponseOutputCsrfTokenMax),
});

export type SessionResponseOutput = zod.input<typeof SessionResponseOutput>;
export type SessionResponseOutputOutput = zod.output<typeof SessionResponseOutput>;
